import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../../context/ThemeContext';

const AchievementCard = ({ icon, title, description, index }) => {
  // const { isDarkMode } = useTheme();
  
  return (
    <div className="relative z-0 group hover:z-10 w-full">
      <motion.div 
        className="relative rounded-[20px] p-8 bg-[#101012] border border-[#333333] overflow-hidden cursor-pointer w-full sm:w-[340px] md:w-[360px] lg:w-[420px] h-[268px] transition-all duration-300 ease-out"
        style={{ transformOrigin: 'top left' }}
        whileHover={{
          scale: 1.038,
          transition: { 
            duration: 0.2, 
            ease: [0.4, 0, 0.2, 1]
          }
        }}
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ 
          opacity: 1, 
          y: 0,
          transition: {
            duration: 0.5,
            delay: index * 0.1,
            ease: "easeOut"
          }
        }}
        viewport={{ 
          once: true, 
          margin: "0px 0px -100px 0px",
          amount: 0.2
        }}
      >
        {/* Pattern Image */}
        <div className="absolute top-0 left-0">
          <img 
            src="/assets/Group 1790.png"
            alt=""
            className="w-full h-full object-contain opacity-90"
          />
        </div>

        {/* Content */}
        <div className="relative z-10 flex flex-col justify-end h-full">
          <div className="flex flex-col gap-4">
            <div className="w-10 h-10">
              {typeof icon === 'string' ? (
                <img 
                  src={icon} 
                  alt={title}
                  className="w-full h-full object-contain"
                />
              ) : (
                <div className="w-full h-full">
                  {icon}
                </div>
              )}
            </div>
            <h3 className="text-[24px] font-medium tracking-[0%] leading-[auto] text-white font-lexend">
              {title}
            </h3>
            <p className="text-[16px] font-light tracking-[0%] leading-[auto] text-white opacity-80 font-lexend">
              {description}
            </p>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

const AchievementsSection = ({ achievements, title = "What You Can Achieve" }) => {
  const { isDarkMode } = useTheme();
  const isGrid2x2 = achievements.length === 4;

  return (
    <section className={`relative py-16 ${isDarkMode ? 'bg-[#000000]' : 'bg-white'}`}>
      <div className={`absolute inset-0 ${isDarkMode ? 'bg-[#000000]' : 'bg-white'}`} />
      
      <div className="relative z-10 max-w-[1300px] mx-auto px-4 sm:px-6 lg:px-8">
        <motion.h2 
          className={`text-[32px] sm:text-[36px] font-medium text-center mb-12 ${
            isDarkMode ? 'text-white' : 'text-black'
          } font-lexend`}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ 
            opacity: 1, 
            y: 0,
            transition: {
              duration: 0.5,
              ease: "easeOut"
            }
          }}
          viewport={{ once: true, amount: 0.2 }}
        >
          {title}
        </motion.h2>

        <div className="flex justify-center">
          <div className={`grid grid-cols-1 ${
            isGrid2x2 
              ? 'md:grid-cols-2 lg:grid-cols-2 max-w-[900px] gap-x-6 md:gap-x-8 lg:gap-x-12 gap-y-6 md:gap-y-8 lg:gap-y-12' 
              : 'md:grid-cols-2 lg:grid-cols-3 gap-x-6 md:gap-x-10 lg:gap-x-24 gap-y-8 md:gap-y-12 lg:gap-y-24'
          } place-items-center w-full`}>
            {achievements.map((achievement, index) => (
              <div className="w-full sm:w-[340px] md:w-full flex justify-center px-4 md:px-2 lg:px-4" key={index}>
                <AchievementCard {...achievement} index={index} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AchievementsSection; 